// Browser-local preference only. Never store passwords or log session values.
export type SessionMode = 'persistent'|'tab';
export const SESSION_MODE_KEY='tableread.sessionMode';
export const AUTH_STORAGE_KEY='sb-ifdgfluvnimwasqkutjg-auth-token';
export function sessionMode():SessionMode {
  try { return window.localStorage.getItem(SESSION_MODE_KEY)==='tab'?'tab':'persistent'; }
  catch { return 'tab'; }
}
export function checkSessionPreferenceStorage() {
  const probe=SESSION_MODE_KEY+'.probe';
  window.localStorage.setItem(probe,'1');window.localStorage.removeItem(probe);
}
export function saveSessionMode(mode:SessionMode) {
  window.localStorage.setItem(SESSION_MODE_KEY,mode);
  // Called only AFTER a successful local sign-out, not during session startup.
  // Remove this app's auth/PKCE copies, never other apps or browser preferences.
  for(const storage of [window.localStorage,window.sessionStorage]) {
    const keys=Array.from({length:storage.length},(_,i)=>storage.key(i));
    for(const k of keys)if(k===AUTH_STORAGE_KEY||k?.startsWith(AUTH_STORAGE_KEY+'-')||k?.startsWith(AUTH_STORAGE_KEY+'.tab'))storage.removeItem(k);
  }
}
export async function applySessionMode(mode:SessionMode,signOut:()=>Promise<{error:unknown}>,navigate:()=>void) {
  checkSessionPreferenceStorage();
  const {error}=await signOut();
  if(error)throw error;
  saveSessionMode(mode);navigate();
}
export function browserSessionStorage(mode:SessionMode=sessionMode()) {
  // Supabase uses storageKey as its BroadcastChannel and lock name. Isolate
  // tab-only clients so another tab cannot silently supply a signed-in user.
  // Map the per-load channel back to a stable sessionStorage key for refresh
  // and OAuth round trips. No private SDK internals or second client instance.
  const canonical=mode==='tab'?AUTH_STORAGE_KEY+'.tab':AUTH_STORAGE_KEY;
  const storageKey=mode==='tab'?`${canonical}.${crypto.randomUUID()}`:canonical;
  const memory=new Map<string,string>();
  const map=(key:string)=>key.startsWith(storageKey)?canonical+key.slice(storageKey.length):key;
  const target=()=>mode==='tab'?window.sessionStorage:window.localStorage;
  return {storageKey,storage:{
    getItem(key:string) {
      if(sessionMode()!==mode)return null;
      try{return target().getItem(map(key))??memory.get(map(key))??null;}catch{return memory.get(map(key))??null;}
    },
    setItem(key:string,value:string) {
      if(sessionMode()!==mode)return;
      try{target().setItem(map(key),value);memory.delete(map(key));}catch{memory.set(map(key),value);}
    },
    removeItem(key:string) {
      memory.delete(map(key));try{target().removeItem(map(key));}catch{/* Fail closed in memory. */}
    },
  }};
}
